import React from 'react';
import { useTranslation } from 'react-i18next';
import { MomentSaved, AppleIcon, AndroidIcon, MobileDashboard } from '/src/images/home';
import DownloadButton from '/src/components/download-button';

const TheCloud = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.companion-app' });

	return (
		<section id="companion-app">
			<div>
				<h3 className="semibold">{t('access-the-same')}</h3>

				<section>
					<aside>
						<div>
							<img src={AppleIcon} alt={t('download-driver-app')} />
							<img src={AndroidIcon} alt={t('download-driver-app')} />
						</div>
						{/* <h4>{t('ios-android')}</h4> */}
						<p>{t('we-wanted')}</p>
						<DownloadButton>{t('download-driver-app')}</DownloadButton>
					</aside>

					<aside>
						<img src={MobileDashboard} alt={t('moment-saved')} />
					</aside>
				</section>
			</div>
		</section>
	);
};

export default TheCloud;
